import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import i18next from 'i18next';
import { useEffect } from 'react';
import { I18nextProvider, initReactI18next } from 'react-i18next';
import { Loading } from '../components/Loading';
import { useConfigurationContext } from '../contexts/ConfigurationContext';
import { getDefaultTranslations } from '../helpers/TranslationHelper';
import { useLocalizationQuery } from '../hooks/useLocalizationQuery';
import { jsx as _jsx } from "react/jsx-runtime";
var DEFAULT_LANGUAGE_KEY = 'default';
var DEFAULT_NAMESPACE = 'translations';
var i18nextInstance = i18next.createInstance({
  keySeparator: '::',
  lng: DEFAULT_LANGUAGE_KEY,
  fallbackLng: DEFAULT_LANGUAGE_KEY,
  defaultNS: DEFAULT_NAMESPACE,
  resources: {},
  interpolation: {
    escapeValue: false,
    // react already safes from xss
    prefix: '{',
    suffix: '}'
  },
  react: {
    bindI18n: 'added removed languageChanged',
    bindI18nStore: 'added removed'
  }
}).use(initReactI18next);
i18nextInstance.init();
export var I18nContainer = function I18nContainer(_ref) {
  var children = _ref.children;

  var _useConfigurationCont = useConfigurationContext(),
      _useConfigurationCont2 = _useConfigurationCont.currentLanguage,
      currentLanguage = _useConfigurationCont2 === void 0 ? DEFAULT_LANGUAGE_KEY : _useConfigurationCont2;

  var preloadedTranslations = getDefaultTranslations();

  var _useLocalizationQuery = useLocalizationQuery(),
      localizationData = _useLocalizationQuery.data;

  useEffect(function () {
    i18nextInstance.addResourceBundle(currentLanguage, DEFAULT_NAMESPACE, _objectSpread(_objectSpread({}, preloadedTranslations), localizationData === null || localizationData === void 0 ? void 0 : localizationData.translations), false, true);
  }, [preloadedTranslations, currentLanguage, localizationData]);
  useEffect(function () {
    i18nextInstance.changeLanguage(currentLanguage);
  }, [currentLanguage]);
  return localizationData ? /*#__PURE__*/_jsx(I18nextProvider, {
    i18n: i18nextInstance,
    children: children
  }) : /*#__PURE__*/_jsx(Loading, {});
};